import {useEffect} from 'react';
import useEvent from './useEvent';

interface IProps {
  isInitOnScroll?: boolean;
  onScroll: (scrollTop: number) => void;
  disabled?: boolean;
}

export default function useOnWindowScroll({
  isInitOnScroll,
  onScroll,
  disabled,
}: IProps) {
  const _onScroll = useEvent(() => {
    onScroll(window.scrollY);
  });

  useEffect(() => {
    if (disabled) return;

    window.addEventListener('scroll', _onScroll);
    isInitOnScroll && _onScroll();
    return () => window.removeEventListener('scroll', _onScroll);
  }, [_onScroll, isInitOnScroll, disabled]);
}
